export default "__VITE_ASSET__Cl4SqNBW__"